/**
 * Which storefront layout family the current tenant's theme preset asks for.
 *
 * The preset (``tenant.branding.theme_preset`` → ``THEME_PRESETS[id].homeLayout``) is the ONLY switch: pages that
 * have a Blinkit-specific view render it when this returns ``"blinkit"`` and render exactly their existing view
 * otherwise. No tenant id, slug or name is ever consulted.
 */
import { useTenant } from "../contexts/TenantContext";
import { THEME_PRESETS } from "./themes";

export function storefrontLayoutFor(tenant) {
    const preset = THEME_PRESETS[tenant?.branding?.theme_preset];
    return preset?.homeLayout || null;
}

export function useStorefrontLayout() {
    const { tenant } = useTenant();
    return storefrontLayoutFor(tenant);
}

export function useIsBlinkit() {
    return useStorefrontLayout() === "blinkit";
}
